import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import { STEPPER_LIST_COUNTRY } from "../../../../constants/cms";
import OverviewForm from "./overviewForm";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountryOverview,
  clearCountryOverview,
  getCountryCurrencyLanguage,
  getCountryPopularPlacesStates,
  putCountryOverview,
} from "../../../../../store/slices/country";
const CountryOverview = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [saveAndNext, setSaveAndNext] = useState(false);
  const user = useSelector((state) => state?.userData?.user?.data);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const dispatch = useDispatch();

  const {
    countryOverviewData,
    countryCurrencyLanguagesData,
    countryPopularPlacesStatesData,
    putCountryOverviewData,
  } = useSelector((state) => state.cmsCountry);
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getCountryOverview({ country_id: id }));
    }
    dispatch(getCountryCurrencyLanguage());
    dispatch(getCountryPopularPlacesStates({ country_id: id }));
    return () => {
      dispatch(clearCountryOverview());
    };
  }, []);
  useEffect(() => {
    if (putCountryOverviewData) {
      if (saveAndNext) {
        navigate(
          `/cms/country/${putCountryOverviewData?.country_id}/basic-detail`
        );
      } else {
        dispatch(getCountryOverview({ country_id: id }));
      }
      setSaveAndNext(false);
    }
  }, [putCountryOverviewData]);
  useEffect(() => {
    if (countryOverviewData && countryCurrencyLanguagesData) {
      let newvalues = {
        country_name: countryOverviewData.country_overview_data?.country_name
          ? countryOverviewData.country_overview_data?.country_name
          : null,
        local_student: countryOverviewData.country_overview_data?.local_student
          ? countryOverviewData.country_overview_data?.local_student
          : null,
        indian_student: countryOverviewData.country_overview_data
          ?.indian_student
          ? countryOverviewData.country_overview_data?.indian_student
          : null,
        international_student: countryOverviewData.country_overview_data
          ?.international_student
          ? countryOverviewData.country_overview_data?.international_student
          : null,
        popular_places_data:
          countryOverviewData.popular_places_data?.length > 0
            ? countryOverviewData.popular_places_data
            : [{ state: null, colleges: null, weight: "" }],
        remark: countryOverviewData.country_overview_data?.remark ?? "",
        status: countryOverviewData.country_overview_data?.status
          ? countryOverviewData.country_overview_data?.status
          : null,
        currency: countryOverviewData.currency
          ? `${countryOverviewData.currency[0].short_name} ${
              countryOverviewData?.currency[0]?.currency_symbol
                ? `(${countryOverviewData.currency[0].currency_symbol})`
                : ""
            }`
          : null,
        primary_language: countryOverviewData.country_overview_data
          ?.primary_language
          ? countryCurrencyLanguagesData?.language_list?.find(
              (obj) =>
                obj.id ==
                countryOverviewData.country_overview_data?.primary_language
            )
          : null,
        other_language: countryOverviewData.country_overview_data
          ?.other_languages
          ? countryCurrencyLanguagesData?.language_list?.filter((obj) =>
              countryOverviewData.country_overview_data?.other_languages.some(
                (item2) => item2 == obj.id
              )
            )
          : null,
        updated_by: countryOverviewData.country_overview_data?.updated_by,
        last_updated: countryOverviewData.country_overview_data?.last_updated,
      };

      setInitialValues(newvalues);
    }
  }, [countryOverviewData || countryCurrencyLanguagesData]);

  const submit = (values) => {
    let data = {};
    data.country_name = values?.country_name;
    data.indian_student =
      values.indian_student === "" ? null : parseInt(values.indian_student);
    data.local_student =
      values.local_student === "" ? null : parseInt(values.local_student);
    data.international_student =
      values.international_student === ""
        ? null
        : parseInt(values.international_student);
    data.popular_places_data = values?.popular_places_data;
    data.remark = values?.remark;
    data.status = values?.status ? 1 : 0;
    data.currency = values?.currency;
    data.primary_language = values?.primary_language?.id;
    data.other_languages =
      values?.other_language.length > 0
        ? values?.other_language.map((val) => val.id)
        : "";
    data.updated_by = user?.id;
    dispatch(putCountryOverview({ country_id: id }, data));
  };
  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper data={STEPPER_LIST_COUNTRY} activeStep={0} />
        </div>
      </div>
      <div>
        {id && (
          <OverviewForm
            submit={(e) => submit(e)}
            initialValues={initialValues}
            setSaveAndNext={setSaveAndNext}
            currencyOptions={countryCurrencyLanguagesData?.currency_list}
            languageOptions={countryCurrencyLanguagesData?.language_list}
            stateOptions={countryPopularPlacesStatesData}
            userPermissions={userPermission}
          />
        )}
      </div>
    </div>
  );
};

export default CountryOverview;
